export default "__VITE_ASSET__P11r5mq$__"